import { render, staticRenderFns } from "./TheIDTNumberUpdateForm.vue?vue&type=template&id=56f10046&"
import script from "./TheIDTNumberUpdateForm.vue?vue&type=script&lang=js&"
export * from "./TheIDTNumberUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports